import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_DOMAINS_STATS } from '../../../../query/monitor/data/sources/keys';
import { getDomainsStats } from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';
import { DomainsStatsResponse } from '../../../../../models/monitor/data/sources/DomainsStatsResponse';

export const useGetDomainsStats = (
  projectId: number | null,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  page?: number,
  pageSize?: number,
  domain?: string[] | null | undefined,
  keyword?: string,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId && !!chatType && !!from && !!to && domain !== null;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: domainsStats,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<DomainsStatsResponse>({
    queryKey: [
      GET_DOMAINS_STATS,
      projectId,
      chatType,
      fromTimestamp,
      toTimestamp,
      page,
      pageSize,
      domain,
      keyword,
      monitorPromptIds,
      filterMonitorTypes,
    ],
    queryFn: () =>
      getDomainsStats(projectId!, false, chatType!, from, to, page, pageSize, domain, keyword, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    domainsStats: queryEnabled
      ? domainsStats ?? {
          domains: [],
        }
      : {
          domains: [],
        },
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [
          GET_DOMAINS_STATS,
          projectId,
          chatType,
          fromTimestamp,
          toTimestamp,
          page,
          pageSize,
          domain,
          keyword,
          monitorPromptIds,
          filterMonitorTypes,
        ],
        refetchType: 'active',
      }),
  };
};
